import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useVociPortale } from '../utils/vociPortale';
import useTicketDaLeggere from '../utils/useTicketDaLeggere';
import { LogOut } from 'lucide-react';
import { useVociPortaleOrdinate } from './menuPortale';

// Voci, ordine e nomi in menuPortale.js (riordinabili da ROOT in Impostazioni → Menu laterale)

export default function SidebarCliente({ mobile, onClose }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const voci = useVociPortale();
  const ticketDaLeggere = useTicketDaLeggere(voci.attivaPath('/cliente/tickets', user));
  const loc = useLocation();
  const NAV = useVociPortaleOrdinate('UTENTE');

  return (
    <div className="app-sidebar" style={mobile ? { ...s.sidebar, height:'100vh', minHeight:0, overflowY:'auto', zIndex:1001, boxShadow:'0 10px 40px rgba(0,0,0,.45)' } : s.sidebar}>
      <div style={s.logoWrap} onClick={() => navigate('/cliente')}>
        <div style={{ fontFamily:"'Barlow Condensed'", fontSize:'var(--font-size-xl)', fontWeight:'800', color:'#F4600C', letterSpacing:'2px' }}>B-CHEERS ASD</div>
      </div>
      <div style={s.divider}/>
      <nav style={s.nav}>
        {NAV.filter(item => !(item.hideIfSocio && user?.is_socio) && voci.attivaPath(item.path, user)).map(({ path, label, icon: Icon }) => {
          const active = loc.pathname === path || (path === '/cliente/fipav' && loc.pathname.startsWith('/cliente/fipav/'));
          const isSocioLink = path === '/cliente/socio';
          return (
            <React.Fragment key={path}>
            <button style={{ ...s.navItem, ...(active ? s.navActive : {}), ...(isSocioLink?{borderTop:'1px solid var(--border)',marginTop:'8px'}:{}) }}
              onClick={() => navigate(path)}>
              <Icon size={16} color={active ? '#F4600C' : isSocioLink ? '#F59E0B' : 'var(--text-dim)'}/>
              <span style={{ fontSize:'var(--font-size-xs)', fontWeight:'700', letterSpacing:'1px', color: active ? 'var(--text)' : isSocioLink ? '#F59E0B' : 'var(--text-muted)', flex:1 }}>{label}</span>
              {path === '/cliente/tickets' && ticketDaLeggere > 0 && (
                <span title="Nuove risposte dallo staff" style={{ fontSize:'10px', fontWeight:'800', color:'#fff', background:'#EF4444', borderRadius:'8px', padding:'1px 7px', marginRight:'6px' }}>{ticketDaLeggere}</span>
              )}
              {active && <div style={s.activeBar}/>}
            </button>
            </React.Fragment>
          );
        })}
      </nav>
      <div style={{ marginTop:'auto' }}>
        <div style={s.divider}/>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', padding:'14px 16px' }}>
          <div style={{ width:'34px', height:'34px', background:'#F4600C', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'var(--font-size-sm)', fontWeight:'700', color:'#fff', flexShrink:0 }}>
            {user?.nome?.[0] || 'C'}
          </div>
          <div>
            <div style={{ fontSize:'var(--font-size-sm)', fontWeight:'600', color:'var(--text)' }}>{user?.nome}</div>
            <div style={{ fontSize:'var(--font-size-xs)', color:'var(--text-dim)' }}>{user?.ruolo || 'SOCIO'}</div>
          </div>
        </div>
        <button style={{ display:'flex', alignItems:'center', gap:'8px', padding:'10px 16px', background:'transparent', border:'none', cursor:'pointer', width:'100%', fontSize:'var(--font-size-xs)', letterSpacing:'1px', color:'var(--text-dim)', fontWeight:'700' }}
          onClick={() => { logout(); navigate('/login'); }}>
          <LogOut size={14} color="#666"/> ESCI
        </button>
      </div>
    </div>
  );
}

const s = {
  sidebar:   { width:'220px', minHeight:'100vh', background:'var(--bg-sidebar)', borderRight:'1px solid var(--border)', display:'flex', flexDirection:'column', position:'fixed', top:0, left:0, zIndex:100 },
  logoWrap:  { padding:'20px 16px', cursor:'pointer' },
  divider:   { height:'1px', background:'var(--bg-input)', margin:'0 16px' },
  nav:       { padding:'16px 8px', display:'flex', flexDirection:'column', gap:'4px' },
  navItem:   { display:'flex', alignItems:'center', gap:'10px', padding:'12px 14px', borderRadius:'8px', border:'none', background:'transparent', cursor:'pointer', position:'relative', width:'100%', textAlign:'left' },
  navActive: { background:'var(--bg-input)' },
  activeBar: { position:'absolute', right:0, top:'50%', transform:'translateY(-50%)', width:'3px', height:'20px', background:'#F4600C', borderRadius:'2px' },
};
